export const transportDocumentSlaughterItemDtoFieldsWithoutWeight = [{
        name: "productTypeName",
        title: "Prodotto",
        render: (record) => record.productTypeName
    }, {
        name: "lotNumber",
        title: "Lotto",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.transportDocumentItem.lotNumber
    }, {
        name: "unit",
        title: "U.M.",
        render: (record) => record.transportDocumentItem.unit
    }, {
        name: "quantity",
        title: "Quantità",
        render: (record) => record.transportDocumentItem.quantity
    }, {
        name: "clfProcessingTypeDescription",
        title: "Lavorazione",
        render: (record) => record.clfProcessingTypeDescription
    }];
export const transportDocumentSlaughterItemDtoFieldsWithWeight = [
    ...transportDocumentSlaughterItemDtoFieldsWithoutWeight, {
        name: "realWeight",
        title: "Peso (orig.)",
        render: (record) => record.transportDocumentItem.realWeight.toFixed(1)
    }, {
        name: "peso",
        title: "Peso (calo)",
        render: (record) => record.transportDocumentItem.weight.toFixed(1)
    }
];
export const transportDocumentSectionItemDtoFieldsWithoutWeight = [{
        name: "productTypeName",
        title: "Prodotto",
        render: (record) => record.productTypeName
    }, {
        name: "lotNumber",
        title: "Lotto",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.transportDocumentItem.lotNumber
        // }, {
        //   name: "quantity",
        //   title: "Quantità",
        //   render: (record: ITransportDocumentItemDTO) => record.transportDocumentItem.quantity
    }];
export const transportDocumentSectionItemDtoFieldsWithWeight = [
    ...transportDocumentSectionItemDtoFieldsWithoutWeight, {
        name: "unit",
        title: "U.M.",
        render: (record) => record.transportDocumentItem.unit
    }, {
        name: "realWeight",
        title: "Peso (orig.)",
        render: (record) => record.transportDocumentItem.realWeight.toFixed(1)
    }, {
        name: "peso",
        title: "Peso (calo)",
        render: (record) => record.transportDocumentItem.weight.toFixed(1)
    }
];
